module.exports = __webpack_public_path__ + "img/logo_Index_acta.1b3e582e.png";